function getTimeString(time) {
	let hour = Number(time);
	let mins = hour === 30 ? 30 : 0;
	if (hour === 0) return "12 a.m.";
	if (hour === 2400) return "midnight";
	if (hour === 1200) return "12 p.m.";
	if (hour === 1230) return "12:30 p.m.";
	if (mins === 30) return "12:30 a.m.";
	// Support military time format
	// e.g. 730 = 7:30 a.m.
	// or 1830 = 6:00 p.m.
	if (String(time).length === 3) {
		hour = String(time).slice(0, 1);
		mins = String(time).slice(1, 3);
	} else if (String(time).length === 4) {
		hour = String(time).slice(0, 2);
		mins = String(time).slice(2, 4);
	}
	if (Number(mins) === 0) {
		mins = ":00";
	} else {
		mins = `:${mins}`;
	}

	return Number(hour) > 12 ? `${hour - 12}${mins} p.m.` : `${hour}${mins} a.m.`;
}

export { getTimeString };
